module.exports = __webpack_public_path__ + "img/version_2.3d8e62cf.png";